import React, { useState, useEffect } from "react";

// components
import AnimationLoading from "../../components/Animationloading";
import EmptyComponent from "../../components/EmptyComponent";
import NavDashboard from "../../components/NavDashboard";
import "./index.css";

// apollo-client
import { GET_DASHBOARD } from "../../apollo/dashboard/query";
import { useLazyQuery } from "@apollo/client";
import { FaUsers } from "react-icons/fa";
import { RiUserStarLine, RiUserShared2Fill } from "react-icons/ri";

// react-bootrap
import { Card, Table } from "react-bootstrap";

export default function ReportCustomer() {
  const [dashboard, setDasBoard] = useState([]);

  // ============== > UseLazyQuery And UseMutaion <==============

  const [LoadDashboard, { data: getdashboard, loading }] = useLazyQuery(
    GET_DASHBOARD,
    { fetchPolicy: "cache-and-network" }
  );

  // ============== > useEffect <==============

  useEffect(() => {
    if (getdashboard) setDasBoard(getdashboard?.dashboard);
  }, [getdashboard]);
 

  console.log("result: ",getdashboard)

  useEffect(() => {
    fetchDashboard();
  }, []);

  // ============== > fuctions <==============

  const fetchDashboard = async () => {
    let shopId = JSON.parse(localStorage.getItem("SHOP_DATA"))?.id;
    await LoadDashboard({
      variables: {
        where: {
          shop: shopId,
        },
      },
    });
  };

  return (
    <NavDashboard title={"ລາຍງານຕາມລູກຄ້າທີ່ມາຊື້"}>
      <div>
        <div className="row">
          <div className="col-4">
            <div className="showProducts shadow-sm">
              <div className="boxIcon">
                <div className="iconName2">
                  <FaUsers />
                </div>
              </div>
              <div className="boxResult">
                <h3> {dashboard?.reportCustomer?.length}</h3>
                <p>ລູກຄ້າທັງໝົດ</p>
              </div>
            </div>
          </div>
          <div className="col-4">
            <div className="showProducts shadow-sm">
              <div className="boxIcon">
                <div className="iconName2">
                  <RiUserStarLine />
                </div>
              </div>
              <div className="boxResult">
                <h3> {dashboard?.reportCustomer?.length}</h3>
                <p>ຍິງ</p>
              </div>
            </div>
          </div>
          <div className="col-4">
            <div className="showProducts shadow-sm">
              <div className="boxIcon">
                <div className="iconName2">
                  <RiUserShared2Fill />
                </div>
              </div>
              <div className="boxResult">
                <h3> {dashboard?.reportCustomer?.length}</h3>
                <p>ຊາຍ</p>
              </div>
            </div>
          </div>
          {/* <div className="col-md-4">
                        <div className="dbox dbox--color-2">
                            <div className="dbox__body">
                                <span className="dbox__count">{dashboard?.reportCustomer?.find((amount) => amount?.amount)}</span>
                                <span className="dbox__title">ຈຳນວນສິນຄ້າທັງໜົດ</span>
                            </div>
                        </div>
                    </div> */}
        </div>

        <div style={{ paddingBottom: "100px" }}>
          {loading && !getdashboard ? (
            <AnimationLoading />
          ) : (
            <>
              {dashboard?.reportCustomer?.length > 0 ? (
                <Card style={{ padding: "3em", marginTop: "1em" }}>
                  <Table striped hover>
                    <thead
                      style={{
                        background: "#1F3A60",
                        color: "white",
                        fontWeight: "400",
                      }}>
                      <tr>
                        <th>ລຳດັບ</th>
                        <th>ຊື່ລູກຄ້າ</th>
                        <th>ນາມສະກຸນ</th>
                        <th>ຈຳນວນສິນຄ້າທີ່ຊື້</th>
                        {/* <th>ຈຳນວນຄັ້ງທີ່ຊື້</th> */}
                        {/* <th>ວັນ/ເດືອນ/ປີ</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {dashboard?.reportCustomer?.map((e, index) => (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{e?.customerName ?? "ລູກຄ້າທົ່ວໄປ"}</td>
                          <td>{e?.customerLastName ?? "-"}</td>
                          <td>{e?.amount ?? "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Card>
              ) : (
                <div>
                  {dashboard?.reportCustomer?.length <= 0 && (
                    <div
                      style={{
                        fontSize: "24px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "#6B7280",
                        fontWeight: "400",
                      }}>
                      <EmptyComponent />
                      <p>ຍັງບໍ່ມີລາຍງານລູກຄ້າ !!!</p>
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </NavDashboard>
  );
}
